import {createAction} from '@ngrx/store';

export const ToggleUserMenu = createAction('[Layout] Toggle user menu');
export const CloseUserMenu = createAction('[Layout] Close user menu');

export const SwitchTheme = createAction('[Layout] Switch theme');
